import { Card, Col } from 'reactstrap'
import { CalendarBootstrap } from '../../../../../utils/Constant'
import BootstrapCalendarBody from './BootstrapCalendarBody'
import CommonCardHeader from '../../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const BootstrapCalendar = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={CalendarBootstrap} />
        <BootstrapCalendarBody/>
      </Card>
    </Col>
  )
}

export default BootstrapCalendar